import consumer from "./consumer";

document.addEventListener("turbolinks:load", () => {
  const listContainer = document.querySelector(".steps[data-list-id]");
  const listId = listContainer?.dataset.listId;
  const channelName = "TaskBlockChannel";

  if (!listId) {
    console.log("No list_id found, subscription not created.");
    return;
  }

  consumer.subscriptions.create({ channel: "TaskBlockChannel" }, {
    connected() {
      console.log(`Connected to ${channelName}`);
    },

    disconnected() {
      console.log(`Disconnected from ${channelName}`);
    },

    received(data) {
      const action = data.action || 'update';
      const taskId = data.task_id;
      const blockId = data.block_id;
      
     
      if (window.activeEditingManager && blockId && window.activeEditingManager.isBlockBeingEdited(blockId)) {
        return;
      }
      
     
      if (action === 'update_value' && blockId && data.hasOwnProperty('value')) {
        const container = document.querySelector(`li#task_${taskId} .tab-panel-content`);
        if (!container) {
          return;
        }
        
        const blockElement = container.querySelector(`[data-block-id="${blockId}"]`);
        if (!blockElement) {
          return;
        }
        
        
        if (data.block_type === 'number') {
          
          const numberDisplay = blockElement.querySelector('.number-display');
          const numberValueElement = blockElement.querySelector('.number-value');
          
          
          const displayValue = data.formatted_value || data.value || '';
          
          if (numberValueElement) {
            
            const oldValue = numberValueElement.textContent;
            numberValueElement.textContent = displayValue;
            
            
            const numberDisplayRow = blockElement.querySelector('.number-display-row');
            if (numberDisplayRow && displayValue) {
              numberDisplayRow.style.display = '';
            }
            
          } else if (numberDisplay && displayValue) {
            
            const span = document.createElement('span');
            span.className = 'number-value';
            span.textContent = displayValue;
            numberDisplay.innerHTML = '';
            numberDisplay.appendChild(span);
            
            
            const numberDisplayRow = blockElement.querySelector('.number-display-row');
            if (numberDisplayRow) {
              numberDisplayRow.style.display = '';
            }
            
          } else if (numberDisplay && !displayValue) {
            
            numberDisplay.innerHTML = '';
            const numberDisplayRow = blockElement.querySelector('.number-display-row');
            if (numberDisplayRow) {
              numberDisplayRow.style.display = 'none';
            }
          } else {
            return; 
          }
          
          
          const numberInputField = blockElement.querySelector('input[type="number"]');
          if (numberInputField) {
            numberInputField.value = data.value || '';
          }
          
          
          if (data.comparison_data) {
            let comparisonDisplay = blockElement.querySelector('[data-target*="comparisonDisplay"]');
            let comparisonWrapper = blockElement.querySelector('.number-comparison-wrapper');
            
            if (!comparisonWrapper && blockElement.querySelector('.number-display-row')) {
              
              comparisonWrapper = document.createElement('div');
              comparisonWrapper.className = 'number-comparison-wrapper';
              blockElement.querySelector('.number-display-row').appendChild(comparisonWrapper);
            }
            
            if (comparisonWrapper) {
              if (!comparisonDisplay) {
                
                comparisonDisplay = document.createElement('span');
                comparisonDisplay.className = 'number-comparison';
                comparisonDisplay.setAttribute('data-target', 'number-input.comparisonDisplay');
                comparisonWrapper.appendChild(comparisonDisplay);
              }
              
              comparisonDisplay.className = `number-comparison ${data.comparison_data.color_class}`;
              comparisonDisplay.innerHTML = `
                <span class="icon comparison-icon ${data.comparison_data.icon}"></span>
                <span>${data.comparison_data.percentage}% (from ${data.comparison_data.formatted_previous_value})</span>
              `;
              comparisonWrapper.classList.remove('hidden');
            }
          }
          
          if (data.account_id && data.project_id && data.task_list_id && taskId && blockId) {
            const event = new CustomEvent('taskBlockUpdated', {
              detail: {
                block_id: blockId,
                account_id: data.account_id,
                project_id: data.project_id,
                task_list_id: data.task_list_id,
                task_id: taskId,
                action: 'update_value'
              }
            });
            document.dispatchEvent(event);

            let url = `/${data.account_id}/projects/${data.project_id}/task_lists/${data.task_list_id}/tasks/${taskId}/task_blocks/${blockId}/render_referencing_task_blocks`;
            let type = 'GET';

            Rails.ajax({
              url: url,
              type: type,
              dataType: "script"
            });
          }
          
          return; 
        } else if (data.block_type === 'formula') {
          
          const formulaDisplay = blockElement.querySelector('.formula-display, .number-display');
          const formulaValueElement = blockElement.querySelector('.formula-value');
          const displayValue = data.formatted_value || data.value || '';
          
          if (formulaValueElement) {
            
            const oldValue = formulaValueElement.textContent;
            formulaValueElement.textContent = displayValue;
            
            
            const numberDisplayRow = blockElement.querySelector('.number-display-row');
            if (numberDisplayRow && displayValue) {
              numberDisplayRow.style.display = '';
            }
            
            
            const formulaEmpty = blockElement.querySelector('.formula-empty');
            if (formulaEmpty) {
              formulaEmpty.remove();
            }
            
          } else if (formulaDisplay && displayValue) {
            
            const span = document.createElement('span');
            span.className = 'formula-value';
            span.textContent = displayValue;
            formulaDisplay.innerHTML = '';
            formulaDisplay.appendChild(span);
            
            
            const numberDisplayRow = blockElement.querySelector('.number-display-row');
            if (numberDisplayRow) {
              numberDisplayRow.style.display = '';
            }
            
            
            const formulaEmpty = blockElement.querySelector('.formula-empty');
            if (formulaEmpty) {
              formulaEmpty.remove();
            }
            
          } else if (formulaDisplay && !displayValue) {
            
            formulaDisplay.innerHTML = '<span class="formula-empty">No formula defined</span>';
            const numberDisplayRow = blockElement.querySelector('.number-display-row');
            if (numberDisplayRow) {
              numberDisplayRow.style.display = '';
            }
          } else {
            return; 
          }
          
          
          if (data.comparison_data) {
            let comparisonDisplay = blockElement.querySelector('[data-target*="comparisonDisplay"]');
            let comparisonWrapper = blockElement.querySelector('.number-comparison-wrapper');
            
            if (!comparisonWrapper && blockElement.querySelector('.number-display-row')) {
              
              comparisonWrapper = document.createElement('div');
              comparisonWrapper.className = 'number-comparison-wrapper';
              blockElement.querySelector('.number-display-row').appendChild(comparisonWrapper);
            }
            
            if (comparisonWrapper) {
              if (!comparisonDisplay) {
                
                comparisonDisplay = document.createElement('span');
                comparisonDisplay.className = 'number-comparison';
                comparisonDisplay.setAttribute('data-target', 'formula-input.comparisonDisplay');
                comparisonWrapper.appendChild(comparisonDisplay);
              }
              
              comparisonDisplay.className = `number-comparison ${data.comparison_data.color_class}`;
              comparisonDisplay.innerHTML = `
                <span class="icon comparison-icon ${data.comparison_data.icon}"></span>
                <span>${data.comparison_data.percentage}% (from ${data.comparison_data.formatted_previous_value})</span>
              `;
              comparisonWrapper.classList.remove('hidden');
            }
          }
          
          if (data.account_id && data.project_id && data.task_list_id && taskId && blockId) {
            const event = new CustomEvent('taskBlockUpdated', {
              detail: {
                block_id: blockId,
                account_id: data.account_id,
                project_id: data.project_id,
                task_list_id: data.task_list_id,
                task_id: taskId,
                action: 'update_value'
              }
            });
            document.dispatchEvent(event);

            let url = `/${data.account_id}/projects/${data.project_id}/task_lists/${data.task_list_id}/tasks/${taskId}/task_blocks/${blockId}/render_referencing_task_blocks`;
            let type = 'GET';

            Rails.ajax({
              url: url,
              type: type,
              dataType: "script"
            });
          }
          
          return; 
        } else if (data.block_type === 'text_input') {
          const textDisplayElement = blockElement.querySelector('[data-target*="textDisplay"]');
          if (textDisplayElement) {
            textDisplayElement.textContent = data.value || '';
            
            if (data.account_id && data.project_id && data.task_list_id && taskId && blockId) {
              const event = new CustomEvent('taskBlockUpdated', {
                detail: {
                  block_id: blockId,
                  account_id: data.account_id,
                  project_id: data.project_id,
                  task_list_id: data.task_list_id,
                  task_id: taskId,
                  action: 'update_value'
                }
              });
              document.dispatchEvent(event);

              let url = `/${data.account_id}/projects/${data.project_id}/task_lists/${data.task_list_id}/tasks/${taskId}/task_blocks/${blockId}/render_referencing_task_blocks`;
              let type = 'GET';

              Rails.ajax({
                url: url,
                type: type,
                dataType: "script"
              });
            }
            
            return; 
          }
        } else if (data.block_type === 'select') {
          const selectElement = blockElement.querySelector('select');
          if (selectElement) {
            const selectedValue = String(data.value || '');
            const currentValue = String(selectElement.value || '');
            
            if (currentValue !== selectedValue) {
              selectElement.value = selectedValue;
              
              const changeEvent = new Event('change', { bubbles: true });
              changeEvent.isChannelUpdate = true;
              selectElement.dispatchEvent(changeEvent);
            }
            
            if (data.account_id && data.project_id && data.task_list_id && taskId && blockId) {
              const event = new CustomEvent('taskBlockUpdated', {
                detail: {
                  block_id: blockId,
                  account_id: data.account_id,
                  project_id: data.project_id,
                  task_list_id: data.task_list_id,
                  task_id: taskId,
                  action: 'update_value'
                }
              });
              document.dispatchEvent(event);

              let url = `/${data.account_id}/projects/${data.project_id}/task_lists/${data.task_list_id}/tasks/${taskId}/task_blocks/${blockId}/render_referencing_task_blocks`;
              let type = 'GET';

              Rails.ajax({
                url: url,
                type: type,
                dataType: "script"
              });
            }
            
            return;
          }
        } else if (data.block_type === 'radio') {
          const radioInputs = blockElement.querySelectorAll('input[type="radio"]');
          if (radioInputs.length > 0) {
            const selectedValue = String(data.value || '');
            radioInputs.forEach(radio => {
              const radioValue = String(radio.value);
              radio.checked = (radioValue === selectedValue);
              
              
              const label = radio.closest('label.radio-button');
              if (label) {
                if (radio.checked) {
                  label.classList.add('checked');
                } else {
                  label.classList.remove('checked');
                }
              }
            });
            
            if (data.account_id && data.project_id && data.task_list_id && taskId && blockId) {
              const event = new CustomEvent('taskBlockUpdated', {
                detail: {
                  block_id: blockId,
                  account_id: data.account_id,
                  project_id: data.project_id,
                  task_list_id: data.task_list_id,
                  task_id: taskId,
                  action: 'update_value'
                }
              });
              document.dispatchEvent(event);

              let url = `/${data.account_id}/projects/${data.project_id}/task_lists/${data.task_list_id}/tasks/${taskId}/task_blocks/${blockId}/render_referencing_task_blocks`;
              let type = 'GET';

              Rails.ajax({
                url: url,
                type: type,
                dataType: "script"
              });
            }
            
            return;
          }
        } else if (data.block_type === 'checkboxes') {
          const checkboxInputs = blockElement.querySelectorAll('input[type="checkbox"]');
          if (checkboxInputs.length > 0) {
            
            const selectedValues = Array.isArray(data.value) ? data.value.map(String) : (data.value ? [String(data.value)] : []);
            checkboxInputs.forEach(checkbox => {
              
              const checkboxValue = String(checkbox.value);
              checkbox.checked = selectedValues.includes(checkboxValue);
              
              
              const label = checkbox.closest('label.checkbox');
              if (label) {
                if (checkbox.checked) {
                  label.classList.add('checked');
                } else {
                  label.classList.remove('checked');
                }
              }
            });
            
            if (data.account_id && data.project_id && data.task_list_id && taskId && blockId) {
              const event = new CustomEvent('taskBlockUpdated', {
                detail: {
                  block_id: blockId,
                  account_id: data.account_id,
                  project_id: data.project_id,
                  task_list_id: data.task_list_id,
                  task_id: taskId,
                  action: 'update_value'
                }
              });
              document.dispatchEvent(event);

              let url = `/${data.account_id}/projects/${data.project_id}/task_lists/${data.task_list_id}/tasks/${taskId}/task_blocks/${blockId}/render_referencing_task_blocks`;
              let type = 'GET';

              Rails.ajax({
                url: url,
                type: type,
                dataType: "script"
              });
            }
            
            return;
          }
        } else if (data.block_type === 'email_address' || data.block_type === 'website_url') {
          const textDisplayElement = blockElement.querySelector('[data-target*="textDisplay"]') ||
                                    blockElement.querySelector('.value-display') ||
                                    blockElement.querySelector('a');
          if (textDisplayElement) {
            if (data.block_type === 'website_url') {
              const displayContainer = textDisplayElement.closest('.input-content') || textDisplayElement;
              
              if (data.value) {
                const existingLink = displayContainer.querySelector('a.url-link');
                const existingCopyButton = displayContainer.querySelector('[data-controller="copy-link"]');
                
                const escapeHtml = (text) => {
                  const div = document.createElement('div');
                  div.textContent = text;
                  return div.innerHTML;
                };
                
                const escapedUrl = escapeHtml(data.value);
                const copyUrlText = document.querySelector('meta[name="i18n-copy_url"]')?.content || 
                                   document.querySelector('meta[name="i18n-app.blocks.copy_url"]')?.content || 
                                   'Copy URL';
                const copiedText = document.querySelector('meta[name="i18n-copied"]')?.content || 
                                  document.querySelector('meta[name="i18n-app.tasks.copied"]')?.content || 
                                  'Copied';
                
                if (displayContainer === textDisplayElement || displayContainer.classList.contains('dynamic-input-content')) {
                  displayContainer.innerHTML = `
                    <a target="_blank" href="${escapedUrl}" class="url-link">${escapedUrl}</a>
                    <span data-controller="copy-link"
                          data-copy-link-content="${escapedUrl}"
                          data-copy-link-success-message="${escapeHtml(copiedText)}"
                          data-target="copy-link.linkText"
                          class="copy_button tiny-link"
                          data-action="click->copy-link#copy">${escapeHtml(copyUrlText)}</span>
                  `;
                  
                  if (window.Stimulus) {
                    const copyButton = displayContainer.querySelector('[data-controller="copy-link"]');
                    if (copyButton) {
                      window.Stimulus.load(copyButton);
                    }
                  }
                } else {
                  if (existingLink) {
                    existingLink.href = data.value;
                    existingLink.textContent = data.value;
                  } else {
                    const link = document.createElement('a');
                    link.target = '_blank';
                    link.href = data.value;
                    link.textContent = data.value;
                    link.className = 'url-link';
                    displayContainer.appendChild(link);
                  }
                  
                  if (existingCopyButton) {
                    existingCopyButton.setAttribute('data-copy-link-content', escapedUrl);
                  } else {
                    const copyButton = document.createElement('span');
                    copyButton.setAttribute('data-controller', 'copy-link');
                    copyButton.setAttribute('data-copy-link-content', escapedUrl);
                    copyButton.setAttribute('data-copy-link-success-message', escapeHtml(copiedText));
                    copyButton.setAttribute('data-target', 'copy-link.linkText');
                    copyButton.className = 'copy_button tiny-link';
                    copyButton.setAttribute('data-action', 'click->copy-link#copy');
                    copyButton.textContent = copyUrlText;
                    displayContainer.appendChild(copyButton);
                    
                    if (window.Stimulus) {
                      window.Stimulus.load(copyButton);
                    }
                  }
                }
              } else {
                if (displayContainer === textDisplayElement || displayContainer.classList.contains('dynamic-input-content')) {
                  displayContainer.innerHTML = '';
                } else {
                  const existingLink = displayContainer.querySelector('a.url-link');
                  const existingCopyButton = displayContainer.querySelector('[data-controller="copy-link"]');
                  if (existingLink) existingLink.remove();
                  if (existingCopyButton) existingCopyButton.remove();
                }
              }
              
              // Update the hidden input field so editing shows the current value
              const inputField = blockElement.querySelector('input[data-target*="inputField"]') ||
                                blockElement.querySelector(`input.block-${blockId}-input`) ||
                                blockElement.querySelector('input.text-field');
              if (inputField) {
                inputField.value = data.value || '';
              }
            } else if (data.block_type === 'email_address') {
              
              const displayContainer = textDisplayElement.closest('.input-content') || textDisplayElement;
              
              if (data.value) {
                const existingLink = displayContainer.querySelector('a[href^="mailto:"]');
                const existingCopyButton = displayContainer.querySelector('[data-controller="copy-link"]');
                
                const escapeHtml = (text) => {
                  const div = document.createElement('div');
                  div.textContent = text;
                  return div.innerHTML;
                };
                
                const escapedEmail = escapeHtml(data.value);
                const copyEmailText = document.querySelector('meta[name="i18n-copy_email"]')?.content || 
                                     document.querySelector('meta[name="i18n-app.blocks.copy_email"]')?.content || 
                                     'Copy email';
                const copiedText = document.querySelector('meta[name="i18n-copied"]')?.content || 
                                  document.querySelector('meta[name="i18n-app.tasks.copied"]')?.content || 
                                  'Copied';
                
                if (displayContainer === textDisplayElement || displayContainer.classList.contains('dynamic-input-content')) {
                  displayContainer.innerHTML = `
                    <a href="mailto:${escapedEmail}">${escapedEmail}</a>
                    <span data-controller="copy-link"
                          data-copy-link-content="${escapedEmail}"
                          data-copy-link-success-message="${escapeHtml(copiedText)}"
                          data-target="copy-link.linkText"
                          class="copy_button tiny-link"
                          data-action="click->copy-link#copy">${escapeHtml(copyEmailText)}</span>
                  `;
                  
                  if (window.Stimulus) {
                    const copyButton = displayContainer.querySelector('[data-controller="copy-link"]');
                    if (copyButton) {
                      window.Stimulus.load(copyButton);
                    }
                  }
                } else {
                  if (existingLink) {
                    existingLink.href = `mailto:${data.value}`;
                    existingLink.textContent = data.value;
                  } else {
                    const link = document.createElement('a');
                    link.href = `mailto:${data.value}`;
                    link.textContent = data.value;
                    displayContainer.appendChild(link);
                  }
                  
                  if (existingCopyButton) {
                    existingCopyButton.setAttribute('data-copy-link-content', escapedEmail);
                  } else {
                    const copyButton = document.createElement('span');
                    copyButton.setAttribute('data-controller', 'copy-link');
                    copyButton.setAttribute('data-copy-link-content', escapedEmail);
                    copyButton.setAttribute('data-copy-link-success-message', escapeHtml(copiedText));
                    copyButton.setAttribute('data-target', 'copy-link.linkText');
                    copyButton.className = 'copy_button tiny-link';
                    copyButton.setAttribute('data-action', 'click->copy-link#copy');
                    copyButton.textContent = copyEmailText;
                    displayContainer.appendChild(copyButton);
                    
                    if (window.Stimulus) {
                      window.Stimulus.load(copyButton);
                    }
                  }
                }
              } else {
                if (displayContainer === textDisplayElement || displayContainer.classList.contains('dynamic-input-content')) {
                  displayContainer.innerHTML = '';
                } else {
                  const existingLink = displayContainer.querySelector('a[href^="mailto:"]');
                  const existingCopyButton = displayContainer.querySelector('[data-controller="copy-link"]');
                  if (existingLink) existingLink.remove();
                  if (existingCopyButton) existingCopyButton.remove();
                }
              }
              
              
              const inputField = blockElement.querySelector('input[data-target*="inputField"]') ||
                                blockElement.querySelector(`input.block-${blockId}-input`) ||
                                blockElement.querySelector('input.text-field');
              if (inputField) {
                inputField.value = data.value || '';
              }
            }
            
            
            if (data.account_id && data.project_id && data.task_list_id && taskId && blockId) {
              const event = new CustomEvent('taskBlockUpdated', {
                detail: {
                  block_id: blockId,
                  account_id: data.account_id,
                  project_id: data.project_id,
                  task_list_id: data.task_list_id,
                  task_id: taskId,
                  action: 'update_value'
                }
              });
              document.dispatchEvent(event);

              let url = `/${data.account_id}/projects/${data.project_id}/task_lists/${data.task_list_id}/tasks/${taskId}/task_blocks/${blockId}/render_referencing_task_blocks`;
              let type = 'GET';

              Rails.ajax({
                url: url,
                type: type,
                dataType: "script"
              });
            }
            
            return;
          }
        } else if (data.block_type === 'signature') {
          
          const signatureController = blockElement.signatureBlockController;
          if (signatureController && data.signature_data && typeof signatureController.updateSignatureDisplay === 'function') {
            const signedAt = data.signed_at ? new Date(data.signed_at) : new Date();
            
            let allowRecreationValue = null;
            if (data.allow_signature_recreation !== undefined) {
              allowRecreationValue = data.allow_signature_recreation === true || data.allow_signature_recreation === "true" || data.allow_signature_recreation === 1;
              signatureController.allowRecreation = allowRecreationValue;
              blockElement.dataset.signatureBlockAllowRecreation = allowRecreationValue ? "true" : "false";
              blockElement.setAttribute('data-signature-block-allow-recreation', allowRecreationValue ? "true" : "false");
            } else {
              const existingValue = blockElement.dataset.signatureBlockAllowRecreation;
              if (existingValue !== undefined) {
                allowRecreationValue = existingValue === "true" || existingValue === true;
                signatureController.allowRecreation = allowRecreationValue;
              } else {
                const attrValue = blockElement.getAttribute('data-signature-block-allow-recreation');
                if (attrValue !== null) {
                  allowRecreationValue = attrValue === "true";
                  signatureController.allowRecreation = allowRecreationValue;
                  blockElement.dataset.signatureBlockAllowRecreation = allowRecreationValue ? "true" : "false";
                }
              }
            }
            signatureController.updateSignatureDisplay(
              data.signature_data,
              data.signed_by_name || '',
              signedAt,
              data.signature_metadata || null,
              allowRecreationValue
            );
            
            
            setTimeout(() => {
              if (signatureController && typeof signatureController.reinitializeAllMaps === 'function') {
                signatureController.reinitializeAllMaps();
              }
            }, 300);
            
            
            if (data.signature_metadata && data.signature_metadata.geolocation) {
              const lat = data.signature_metadata.geolocation.latitude;
              const lng = data.signature_metadata.geolocation.longitude;
              if (lat != null && lng != null) {
                
                const tryInitializeMap = (attempt = 0) => {
                  if (attempt > 15) {
                    
                    if (signatureController && typeof signatureController.reinitializeAllMaps === 'function') {
                      signatureController.reinitializeAllMaps();
                    }
                    return;
                  }
                  
                  const signatureField = blockElement.querySelector('.signature-field');
                  if (!signatureField) {
                    setTimeout(() => tryInitializeMap(attempt + 1), 150);
                    return;
                  }
                  
                  const mapElement = signatureField.querySelector('.signature-location-map');
                  if (mapElement && mapElement.id) {
                    if (!mapElement._leafletMap && !mapElement._leafletInitialized) {
                      const clickHandler = (e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        if (signatureController && typeof signatureController.openLocationModal === 'function') {
                          signatureController.openLocationModal(e);
                        }
                      };
                      mapElement.addEventListener('click', clickHandler);
                      signatureController.initializeLeafletMap(mapElement.id, lat, lng, clickHandler);
                    } else if (mapElement._leafletMap) {
                      
                      return;
                    }
                  } else {
                    
                    setTimeout(() => tryInitializeMap(attempt + 1), 150);
                  }
                };
                
                
                setTimeout(() => tryInitializeMap(0), 200);
                setTimeout(() => tryInitializeMap(0), 500);
                setTimeout(() => tryInitializeMap(0), 1000);
              }
            }
            
            if (data.account_id && data.project_id && data.task_list_id && taskId && blockId) {
              const event = new CustomEvent('taskBlockUpdated', {
                detail: {
                  block_id: blockId,
                  account_id: data.account_id,
                  project_id: data.project_id,
                  task_list_id: data.task_list_id,
                  task_id: taskId,
                  action: 'update_value'
                }
              });
              document.dispatchEvent(event);

              const renderUrl = `/${data.account_id}/projects/${data.project_id}/task_lists/${data.task_list_id}/tasks/${taskId}/task_blocks/${blockId}/render_referencing_task_blocks`;
              if (typeof Rails !== 'undefined' && Rails.ajax) {
                Rails.ajax({
                  url: renderUrl,
                  type: 'GET',
                  dataType: "script"
                });
              } else {
                fetch(renderUrl, {
                  method: 'GET',
                  headers: {
                    'Accept': 'text/javascript',
                    'X-Requested-With': 'XMLHttpRequest',
                    'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
                  },
                  credentials: 'same-origin'
                });
              }
            }
            
            return;
          }
          
          
          const signatureField = blockElement.querySelector('.signature-field');
          if (signatureField && data.signature_data) {
            
            const existingDisplay = signatureField.querySelector('.signature-display');
            if (existingDisplay) {
              const existingMap = existingDisplay.querySelector('.signature-location-map');
              if (existingMap && existingMap._leafletMap) {
                try {
                  existingMap._leafletMap.remove();
                } catch (e) {}
              }
              existingDisplay.remove();
            }
            
            const inputContainer = signatureField.querySelector('.signature-input-container');
            if (inputContainer) {
              inputContainer.remove();
            }
            
            
            const signatureDisplay = document.createElement('div');
            signatureDisplay.className = 'signature-display';
            signatureDisplay.style.cssText = 'display: flex; gap: 15px; align-items: flex-start;';
            
            const imageWrapper = document.createElement('div');
            imageWrapper.className = 'signature-image-wrapper';
            
            const imageContainer = document.createElement('div');
            imageContainer.className = 'signature-image-container';
            
            const img = document.createElement('img');
            img.src = data.signature_data;
            img.alt = 'Signature';
            img.className = 'signature-image';
            img.style.cssText = 'max-width: 300px; border: 1px solid #ddd; padding: 10px; background: white;';
            imageContainer.appendChild(img);
            
            const meta = document.createElement('div');
            meta.className = 'signature-meta';
            meta.style.cssText = 'margin-top: 10px; font-size: 14px; color: #666;';
            
            if (data.signed_by_name) {
              const nameSpan = document.createElement('span');
              nameSpan.className = 'signature-name';
              nameSpan.style.cssText = 'font-weight: bold; margin-right: 10px;';
              
              let displayText = data.signed_by_name;
              if (data.signature_metadata && data.signature_metadata.signed_by_email) {
                displayText = `${data.signed_by_name} (user: ${data.signature_metadata.signed_by_email})`;
              }
              nameSpan.textContent = displayText;
              meta.appendChild(nameSpan);
            }
            
            if (data.signed_at) {
              const dateSpan = document.createElement('span');
              dateSpan.className = 'signature-date';
              dateSpan.setAttribute('data-utc-time', data.signed_at);
              
              const date = new Date(data.signed_at);
              dateSpan.textContent = date.toLocaleString();
              meta.appendChild(dateSpan);
            }
            
            imageWrapper.appendChild(imageContainer);
            imageWrapper.appendChild(meta);
            
            const allowRecreation = data.allow_signature_recreation === true || data.allow_signature_recreation === "true" || data.allow_signature_recreation === 1;
            const isReadOnly = blockElement.dataset.signatureBlockReadOnly === "true" || blockElement.getAttribute('data-signature-block-read-only') === "true";
            
            if (allowRecreation && !isReadOnly) {
              if (data.allow_signature_recreation !== undefined) {
                blockElement.dataset.signatureBlockAllowRecreation = allowRecreation ? "true" : "false";
                blockElement.setAttribute('data-signature-block-allow-recreation', allowRecreation ? "true" : "false");
                if (signatureController) {
                  signatureController.allowRecreation = allowRecreation;
                }
              }
              
              const buttonContainer = document.createElement('div');
              buttonContainer.style.cssText = 'margin-top: 10px;';
              
              let buttonColor = '#005ca5';
              const existingButton = blockElement.querySelector('.button');
              if (existingButton) {
                const computedStyle = window.getComputedStyle(existingButton);
                const bgColor = computedStyle.backgroundColor;
                if (bgColor && bgColor !== 'rgba(0, 0, 0, 0)' && bgColor !== 'transparent') {
                  buttonColor = bgColor;
                }
              }
              
              const button = document.createElement('button');
              button.type = 'button';
              button.className = 'button signature-recreate-button';
              button.setAttribute('data-action', 'click->signature-block#openSignatureModal');
              button.style.cssText = `padding: 8px 16px; font-size: 14px; background: ${buttonColor} !important;`;
              
              const iconSpan = document.createElement('span');
              iconSpan.className = 'icon icon-pencil';
              button.appendChild(iconSpan);
              
              const textSpan = document.createElement('span');
              const buttonText = document.querySelector('meta[name="i18n-app.block_forms.record_new_signature"]')?.content || 
                                'Record New Signature';
              textSpan.textContent = buttonText;
              button.appendChild(textSpan);
              
              buttonContainer.appendChild(button);
              imageWrapper.appendChild(buttonContainer);
            }
            
            signatureDisplay.appendChild(imageWrapper);
            
            
            if (data.signature_metadata && data.signature_metadata.geolocation) {
              const lat = data.signature_metadata.geolocation.latitude;
              const lng = data.signature_metadata.geolocation.longitude;
              if (lat != null && lng != null) {
                const mapContainer = document.createElement('div');
                mapContainer.className = 'signature-location-map-container';
                mapContainer.style.cssText = 'flex-shrink: 0; position: relative; z-index: 1;';
                
                const mapId = `signature-map-${blockId}-${Date.now()}`;
                const mapDiv = document.createElement('div');
                mapDiv.className = 'signature-location-map';
                mapDiv.id = mapId;
                mapDiv.setAttribute('data-latitude', lat);
                mapDiv.setAttribute('data-longitude', lng);
                mapDiv.style.cssText = 'width: 200px; height: 200px; border: 2px solid #ddd; border-radius: 4px; cursor: pointer; overflow: hidden; background: #f5f5f5; position: relative; z-index: 1;';
                
                const mapLabel = document.createElement('div');
                mapLabel.style.cssText = 'position: absolute; bottom: 0; left: 0; right: 0; background: rgba(0,0,0,0.6); color: white; padding: 5px; font-size: 11px; text-align: center; pointer-events: none; z-index: 10;';
                mapLabel.textContent = 'Click to view location';
                mapDiv.appendChild(mapLabel);
                
                mapContainer.appendChild(mapDiv);
                signatureDisplay.appendChild(mapContainer);
                
                const clickHandler = (e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  if (signatureController && typeof signatureController.openLocationModal === 'function') {
                    signatureController.openLocationModal(e);
                  }
                };
                
                mapDiv.addEventListener('click', clickHandler);
                
                
                const initializeMapWithRetry = (attempt = 0) => {
                  if (attempt > 5) {
                   
                    const controller = blockElement.signatureBlockController;
                    if (controller && typeof controller.reinitializeAllMaps === 'function') {
                      controller.reinitializeAllMaps();
                    }
                    return;
                  }
                  
                  const controller = blockElement.signatureBlockController;
                  if (controller && typeof controller.initializeLeafletMap === 'function') {
                    controller.initializeLeafletMap(mapId, lat, lng, clickHandler);
                  } else if (attempt < 5) {
                    
                    setTimeout(() => initializeMapWithRetry(attempt + 1), 200);
                  }
                };
                
               
                setTimeout(() => initializeMapWithRetry(0), 150);
                setTimeout(() => initializeMapWithRetry(0), 500);
                setTimeout(() => initializeMapWithRetry(0), 1000);
                
                
                setTimeout(() => {
                  const controller = blockElement.signatureBlockController;
                  if (controller && typeof controller.reinitializeAllMaps === 'function') {
                    controller.reinitializeAllMaps();
                  }
                }, 1200);
              }
            }
            
            signatureField.appendChild(signatureDisplay);
            
            
            blockElement.dataset.signatureBlockSignatureData = data.signature_data;
            blockElement.dataset.signatureBlockSignedByName = data.signed_by_name || '';
            blockElement.dataset.signatureBlockSignedAt = data.signed_at || '';
            if (data.signature_metadata) {
              blockElement.dataset.signatureBlockMetadata = JSON.stringify(data.signature_metadata);
            }
            
            
            setTimeout(() => {
              const controller = blockElement.signatureBlockController;
              if (controller && typeof controller.reinitializeAllMaps === 'function') {
                controller.reinitializeAllMaps();
              }
              
              
              const allSignatureBlocks = document.querySelectorAll('[data-controller*="signature-block"]');
              allSignatureBlocks.forEach(blockEl => {
                if (blockEl.signatureBlockController && typeof blockEl.signatureBlockController.reinitializeAllMaps === 'function') {
                  blockEl.signatureBlockController.reinitializeAllMaps();
                }
              });
            }, 400);
            
            if (data.account_id && data.project_id && data.task_list_id && taskId && blockId) {
              const event = new CustomEvent('taskBlockUpdated', {
                detail: {
                  block_id: blockId,
                  account_id: data.account_id,
                  project_id: data.project_id,
                  task_list_id: data.task_list_id,
                  task_id: taskId,
                  action: 'update_value'
                }
              });
              document.dispatchEvent(event);

              const renderUrl = `/${data.account_id}/projects/${data.project_id}/task_lists/${data.task_list_id}/tasks/${taskId}/task_blocks/${blockId}/render_referencing_task_blocks`;
              if (typeof Rails !== 'undefined' && Rails.ajax) {
                Rails.ajax({
                  url: renderUrl,
                  type: 'GET',
                  dataType: "script"
                });
              } else {
                fetch(renderUrl, {
                  method: 'GET',
                  headers: {
                    'Accept': 'text/javascript',
                    'X-Requested-With': 'XMLHttpRequest',
                    'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
                  },
                  credentials: 'same-origin'
                });
              }
            }
            
            return;
          }
        } else if (data.block_type === 'rich_text_input' || data.block_type === 'email_template' || data.block_type === 'ai_text_generator') {
          
          if (data.block_html) {
            const blockTmp = document.createElement('div');
            blockTmp.innerHTML = data.block_html;
            
            
            const formElement = blockTmp.querySelector('form.step-content-form');
            let newBlockElement = null;
            
            if (formElement) {
              
              const blocksContainer = formElement.querySelector('.blocks');
              if (blocksContainer) {
                newBlockElement = blocksContainer.querySelector(`[data-block-id="${blockId}"]`) ||
                                 blocksContainer.querySelector(`.block-type-${data.block_type.replace('_', '-')}`) ||
                                 blocksContainer.querySelector('.block');
              } else {
                
                newBlockElement = formElement.querySelector(`[data-block-id="${blockId}"]`) ||
                                 formElement.querySelector(`.block-type-${data.block_type.replace('_', '-')}`) ||
                                 formElement.querySelector('.block');
              }
            } else {
              
              newBlockElement = blockTmp.querySelector(`[data-block-id="${blockId}"]`) ||
                               blockTmp.querySelector(`.block-type-${data.block_type.replace('_', '-')}`) ||
                               blockTmp.querySelector('.block');
            }
            
            if (newBlockElement && blockElement) {
              
              blockElement.outerHTML = newBlockElement.outerHTML;
              
              
              if (window.Stimulus) {
                const updatedBlockElement = container.querySelector(`[data-block-id="${blockId}"]`);
                if (updatedBlockElement) {
                  window.Stimulus.load(updatedBlockElement);
                }
              }
            }
            
            return;
          }
          
          
          const richTextDisplay = blockElement.querySelector('.rich-text-content') ||
                                 blockElement.querySelector('.froala-view') ||
                                 blockElement.querySelector('[data-target*="content"]');
          if (richTextDisplay) {
            
            richTextDisplay.innerHTML = data.value || '';
            
            
            const editorWrapper = blockElement.querySelector('.froala-editor-wrapper');
            if (editorWrapper) {
              editorWrapper.classList.add('hidden');
              
             
              const textarea = editorWrapper.querySelector('textarea.froala');
              if (textarea) {
                
                const rawValue = data.raw_value !== undefined ? data.raw_value : data.value || '';
                textarea.value = rawValue;
                
               
                if (textarea.froalaEditor) {
                  textarea.froalaEditor.html.set(rawValue);
                }
              }
            }
 
          
            
            return;
          }
        } else if (data.block_type === 'datetime') {
          // Find the date and time display elements
          const dateElement = blockElement.querySelector('.display-datetime .datetime .date');
          const timeElement = blockElement.querySelector('.display-datetime .datetime .time');
          const flatpickrElement = blockElement.querySelector('.flatpickr');
          
          if (dateElement && timeElement && data.value) {
            try {
              
              const updatedDate = new Date(data.value);
              
              if (!isNaN(updatedDate.getTime())) {
                const dateFormat = data.date_format || flatpickrElement?.dataset.dateFormat || "%b %e, %Y";
                
                
                const convertRailsDateFormat = (railsFormat) => {
                  const formatMap = {
                    "%Y": "Y",  // Year (4-digit)
                    "%y": "y",  // Year (2-digit)
                    "%m": "m",  // Month (zero-padded)
                    "%-m": "n", // Month (no padding)
                    "%b": "M",  // Abbreviated month (e.g., "Jan")
                    "%B": "F",  // Full month name (e.g., "January")
                    "%d": "d",  // Day (zero-padded)
                    "%-d": "j", // Day (no padding)
                    "%e": "j",  // Day (no padding, same as `%-d`)
                    "%A": "l",  // Full weekday name (e.g., "Monday")
                  };
                  
                  let flatpickrFormat = railsFormat;
                  Object.keys(formatMap).forEach((key) => {
                    flatpickrFormat = flatpickrFormat.replace(new RegExp(key.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), "g"), formatMap[key]);
                  });
                  
                  return flatpickrFormat;
                };
                
                // Format the date
                const flatpickrFormat = convertRailsDateFormat(dateFormat);
                
                const flatpickrLib = typeof flatpickr !== 'undefined' ? flatpickr : (typeof window !== 'undefined' && window.flatpickr ? window.flatpickr : null);
                if (flatpickrLib && typeof flatpickrLib.formatDate === 'function') {
                  dateElement.textContent = flatpickrLib.formatDate(updatedDate, flatpickrFormat);
                } else {
                  
                  const formatMap = {
                    "%b": "short",  // Abbreviated month
                    "%B": "long",   // Full month
                    "%e": "numeric", // Day
                    "%d": "2-digit", // Day with zero padding
                    "%Y": "numeric", // Year
                    "%y": "2-digit"  // 2-digit year
                  };
                  
                  
                  const options = { 
                    year: 'numeric', 
                    month: 'short', 
                    day: 'numeric' 
                  };
                  dateElement.textContent = updatedDate.toLocaleDateString('en-US', options);
                }
                
                
                timeElement.textContent = updatedDate.toLocaleTimeString([], {
                  hour: '2-digit', 
                  minute: '2-digit', 
                  hour12: true
                });
                
                
                const hiddenInput = blockElement.querySelector('input[type="datetime-local"], input[type="datetime"]');
                if (hiddenInput) {
                  
                  const year = updatedDate.getFullYear();
                  const month = String(updatedDate.getMonth() + 1).padStart(2, "0");
                  const day = String(updatedDate.getDate()).padStart(2, "0");
                  const hours = String(updatedDate.getHours()).padStart(2, "0");
                  const minutes = String(updatedDate.getMinutes()).padStart(2, "0");
                  hiddenInput.value = `${year}-${month}-${day}T${hours}:${minutes}`;
                }
                
                
                if (flatpickrElement) {
                  flatpickrElement.classList.add('has-value');
                  
                  const clearIcon = blockElement.querySelector('.display-datetime .datetime-actions .icon.clear');
                  if (clearIcon) {
                    clearIcon.classList.remove('hidden');
                  }
                }
                
                
                const dateDifferenceElement = blockElement.querySelector('.date-difference-value');
                if (dateDifferenceElement) {
                  const flatpickrUserTimezone = flatpickrElement?.dataset.flatpickrUserTimezone || Intl.DateTimeFormat().resolvedOptions().timeZone;
                  
                  
                  const calculateNiceDateDifference = (selectedDate, userTimezone) => {
                    const currentDate = new Date(new Date().toLocaleString('en-US', { timeZone: userTimezone }));
                    const timeDifference = currentDate - selectedDate;
                    let result = '';

                    const secondsInMinute = 60;
                    const secondsInHour = 3600;
                    const secondsInDay = 86400;
                    const secondsInWeek = 604800;
                    const secondsInMonth = 2592000;
                    const secondsInYear = 31536000;

                    function t(key) {
                      return document.querySelector(`meta[name="i18n-${key}"]`)?.content || key;
                    }

                    if (timeDifference < secondsInMinute * 1000) {
                      result = t("just-now");
                    } else if (timeDifference < secondsInHour * 1000) {
                      result = `${Math.floor(timeDifference / (secondsInMinute * 1000))} ${t("minutes")} ${t('ago')}`;
                    } else if (timeDifference < secondsInDay * 1000) {
                      result = `${Math.floor(timeDifference / (secondsInHour * 1000))} ${t("hours")} ${t('ago')}`;
                    } else if (timeDifference < secondsInWeek * 1000) {
                      result = `${Math.floor(timeDifference / (secondsInDay * 1000))} ${t("days")} ${t('ago')}`;
                    } else if (timeDifference < secondsInMonth * 1000) {
                      result = `${Math.floor(timeDifference / (secondsInWeek * 1000))} ${t("weeks")} ${t('ago')}`;
                    } else if (timeDifference < secondsInYear * 1000) {
                      result = `${Math.floor(timeDifference / (secondsInMonth * 1000))} ${t("months")} ${t('ago')}`;
                    } else {
                      result = `${Math.floor(timeDifference / (secondsInYear * 1000))} ${t("years")} ${t('ago')}`;
                    }

                    if (timeDifference < 0) {
                      if (Math.abs(timeDifference) < secondsInMinute * 1000) {
                        result = t("just-now");
                      } else if (Math.abs(timeDifference) < secondsInHour * 1000) {
                        result = `${Math.floor(Math.abs(timeDifference) / (secondsInMinute * 1000))} ${t("minutes")} ${t('from-now')}`;
                      } else if (Math.abs(timeDifference) < secondsInDay * 1000) {
                        result = `${Math.floor(Math.abs(timeDifference) / (secondsInHour * 1000))} ${t("hours")} ${t('from-now')}`;
                      } else if (Math.abs(timeDifference) < secondsInWeek * 1000) {
                        result = `${Math.floor(Math.abs(timeDifference) / (secondsInDay * 1000))} ${t("days")} ${t('from-now')}`;
                      } else if (Math.abs(timeDifference) < secondsInMonth * 1000) {
                        result = `${Math.floor(Math.abs(timeDifference) / (secondsInWeek * 1000))} ${t("weeks")} ${t('from-now')}`;
                      } else if (Math.abs(timeDifference) < secondsInYear * 1000) {
                        result = `${Math.floor(Math.abs(timeDifference) / (secondsInMonth * 1000))} ${t("months")} ${t('from-now')}`;
                      } else {
                        result = `${Math.floor(Math.abs(timeDifference) / (secondsInYear * 1000))} ${t("years")} ${t('from-now')}`;
                      }
                    }

                    if (Math.abs(timeDifference) < secondsInDay * 1000) {
                      const tomorrow = new Date(currentDate.getTime() + secondsInDay * 1000);
                      if (selectedDate.getTime() === tomorrow.getTime()) {
                        result = t("tomorrow");
                      }
                    }

                    if (Math.abs(timeDifference) < secondsInDay * 1000 * 2) {
                      const dayAfterTomorrow = new Date(currentDate.getTime() + secondsInDay * 1000 * 2);
                      if (selectedDate.getTime() === dayAfterTomorrow.getTime()) {
                        result = "day after tomorrow";
                      }
                    }

                    return result;
                  };
                  
                  const niceDateDifference = calculateNiceDateDifference(updatedDate, flatpickrUserTimezone);
                  dateDifferenceElement.textContent = niceDateDifference;
                }
              } else {
                // Clear display if invalid date
                dateElement.textContent = '';
                timeElement.textContent = '';
                if (flatpickrElement) {
                  flatpickrElement.classList.remove('has-value');
                  const clearIcon = blockElement.querySelector('.display-datetime .datetime-actions .icon.clear');
                  if (clearIcon) {
                    clearIcon.classList.add('hidden');
                  }
                }
                // Clear nice date difference
                const dateDifferenceElement = blockElement.querySelector('.date-difference-value');
                if (dateDifferenceElement) {
                  const just_now = document.querySelector('meta[name="i18n-just_now"]')?.content || 'Just Now';
                  dateDifferenceElement.textContent = just_now;
                }
              }
            } catch (error) {
              console.error("Error updating datetime display:", error);
            }
          } else if (dateElement && timeElement && !data.value) {
            // Clear display if no value
            dateElement.textContent = '';
            timeElement.textContent = '';
            if (flatpickrElement) {
              flatpickrElement.classList.remove('has-value');
              const clearIcon = blockElement.querySelector('.display-datetime .datetime-actions .icon.clear');
              if (clearIcon) {
                clearIcon.classList.add('hidden');
              }
            }
            // Clear nice date difference
            const dateDifferenceElement = blockElement.querySelector('.date-difference-value');
            if (dateDifferenceElement) {
              const just_now = document.querySelector('meta[name="i18n-just_now"]')?.content || 'Just Now';
              dateDifferenceElement.textContent = just_now;
            }
          }
          
          if (data.account_id && data.project_id && data.task_list_id && taskId && blockId) {
            const event = new CustomEvent('taskBlockUpdated', {
              detail: {
                block_id: blockId,
                account_id: data.account_id,
                project_id: data.project_id,
                task_list_id: data.task_list_id,
                task_id: taskId,
                action: 'update_value'
              }
            });
            document.dispatchEvent(event);

            let url = `/${data.account_id}/projects/${data.project_id}/task_lists/${data.task_list_id}/tasks/${taskId}/task_blocks/${blockId}/render_referencing_task_blocks`;
            let type = 'GET';

            Rails.ajax({
              url: url,
              type: type,
              dataType: "script"
            });
          }
          
          return;
        } else if (data.block_type === 'look_up_field') {
          const selectElement = blockElement.querySelector('select');
          if (selectElement) {
            const selectedValues = Array.isArray(data.value) 
              ? data.value.map(v => String(v)) 
              : (data.value ? [String(data.value)] : []);
            
            let currentValues = [];
            if (selectElement.slimSelectInstance) {
              currentValues = (selectElement.slimSelectInstance.getSelected() || []).map(v => String(v));
            } else {
              currentValues = Array.from(selectElement.selectedOptions).map(opt => String(opt.value));
            }
            
            const currentSorted = [...currentValues].sort().join(',');
            const selectedSorted = [...selectedValues].sort().join(',');
            const valuesChanged = currentSorted !== selectedSorted;
            
            if (valuesChanged) {
              if (selectElement.slimSelectInstance) {
                selectElement._isProgrammaticChange = true;
                selectElement.slimSelectInstance.setSelected(selectedValues);
                
                const controllerInstance = selectElement.lookupController;
                if (controllerInstance) {
                  const currentSelection = selectedSorted;
                  controllerInstance.previousSelections.set(selectElement, currentSelection);
                }
              } else {
                Array.from(selectElement.options).forEach(option => {
                  option.selected = selectedValues.includes(String(option.value));
                });
                
                const changeEvent = new Event('change', { bubbles: true });
                changeEvent.isChannelUpdate = true;
                selectElement.dispatchEvent(changeEvent);
              }
            }
            
            if (data.account_id && data.project_id && data.task_list_id && taskId && blockId) {
              const event = new CustomEvent('taskBlockUpdated', {
                detail: {
                  block_id: blockId,
                  account_id: data.account_id,
                  project_id: data.project_id,
                  task_list_id: data.task_list_id,
                  task_id: taskId,
                  action: 'update_value'
                }
              });
              document.dispatchEvent(event);

              let url = `/${data.account_id}/projects/${data.project_id}/task_lists/${data.task_list_id}/tasks/${taskId}/task_blocks/${blockId}/render_referencing_task_blocks`;
              let type = 'GET';

              Rails.ajax({
                url: url,
                type: type,
                dataType: "script"
              });
            }
            
            return;
          }
        }
        
        return;
      }

      if (action === 'update_comparison_project' && blockId && (data.block_type === 'number' || data.block_type === 'formula')) {
        const container = document.querySelector(`li#task_${taskId} .tab-panel-content`);
        if (!container) {
          return;
        }
        
        const blockElement = container.querySelector(`[data-block-id="${blockId}"]`);
        if (!blockElement) {
          return;
        }
        
        const comparisonSelect = blockElement.querySelector('select.comparison-project-select[data-target*="comparisonSelect"]') ||
                                 blockElement.querySelector('select.comparison-project-select');
        
        if (comparisonSelect) {
          const newProjectId = data.comparison_project_id ? String(data.comparison_project_id) : '';
          const currentValue = comparisonSelect.value || '';
          if (currentValue !== newProjectId) {
            comparisonSelect.value = newProjectId;
          }
          
          if (data.comparison_data || data.comparison_project_id) {
            const updateEvent = new CustomEvent('comparisonProjectUpdated', {
              detail: {
                comparison_project_id: data.comparison_project_id,
                comparison_data: data.comparison_data
              },
              bubbles: true
            });
            comparisonSelect.dispatchEvent(updateEvent);
          }
        }
        
        if (data.comparison_data) {
          const displayUpdateEvent = new CustomEvent('comparisonDisplayUpdate', {
            detail: {
              comparison_data: data.comparison_data
            },
            bubbles: true
          });
          blockElement.dispatchEvent(displayUpdateEvent);
        } else {
          const removeDisplayEvent = new CustomEvent('comparisonDisplayRemove', {
            bubbles: true
          });
          blockElement.dispatchEvent(removeDisplayEvent);
        }
        
        return;
      }

      if (action === 'remove_file' && blockId && data.attachment_id) {
        const container = document.querySelector(`li#task_${taskId} .tab-panel-content`);
        if (!container) {
          return;
        }
        
        const blockElement = container.querySelector(`[data-block-id="${blockId}"]`);
        if (!blockElement) {
          return;
        }
        
        const filePreview = blockElement.querySelector(`.file-preview[data-file-id="${data.attachment_id}"]`);
        
        if (filePreview) {
          const attachmentPreview = filePreview.closest('.file-attachment-preview');
          
          if (attachmentPreview) {
            attachmentPreview.remove();
            
            const attachmentActions = blockElement.querySelector('.attachment-actions');
            if (attachmentActions) {
              const remainingPreviews = attachmentActions.querySelectorAll('.file-attachment-preview');
              if (remainingPreviews.length === 0) {
                attachmentActions.remove();
                
                const fieldElement = blockElement.querySelector('.field');
                const searchContainer = fieldElement || blockElement;
                
                if (searchContainer) {
                  const uppyButton = searchContainer.querySelector(`button[data-block-id="${blockId}"][data-action*="uppyClick"]`) ||
                                     searchContainer.querySelector(`button[data-block-id="${blockId}"]`);
                  
                  if (uppyButton) {
                    const iconPlus = uppyButton.querySelector('.icon-plus');
                    if (iconPlus) {
                      iconPlus.remove();
                      
                      const currentText = uppyButton.textContent.trim();
                      
                      const words = currentText.split(/\s+/);
                      if (words.length >= 2) {
                        const filesText = words[words.length - 1];
                        uppyButton.textContent = `Upload ${filesText}`;
                      } else {
                        uppyButton.textContent = 'Upload Files';
                      }
                      
                      const currentStyle = uppyButton.getAttribute('style') || '';
                      const updatedStyle = currentStyle.replace(/margin-top:\s*20px[;]?/gi, '').trim();
                      if (updatedStyle) {
                        uppyButton.setAttribute('style', updatedStyle);
                      } else {
                        uppyButton.removeAttribute('style');
                      }
                    }
                  }
                  
                  const blockContainer = blockElement.closest('[data-upload-action]');
                  if (blockContainer) {
                    blockContainer.setAttribute('data-upload-action', 'upload');
                  }
                }
              }
            }
          }
          
          const fileModal = document.querySelector(`#file-modal-${data.attachment_id}`);
          if (fileModal) {
            fileModal.remove();
          }
        }
        
        return;
      }

      if (action === 'attach_files' && blockId && data.attachment_html && data.attachment_html.trim() !== '') {
        const container = document.querySelector(`li#task_${taskId} .tab-panel-content`);
        if (!container) {
          return;
        }
        
        const blockElement = container.querySelector(`[data-block-id="${blockId}"]`);
        if (!blockElement) {
          return;
        }
        
        const fieldElement = blockElement.querySelector('.field');
        if (!fieldElement) {
          return;
        }
        
        let attachmentActions = fieldElement.querySelector('.attachment-actions');
        
        if (attachmentActions) {
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = data.attachment_html;
          const newAttachmentActions = tempDiv.querySelector('.attachment-actions');
          
          if (newAttachmentActions) {
            attachmentActions.replaceWith(newAttachmentActions);
            
            const newModals = tempDiv.querySelectorAll('.file-modal');
            newModals.forEach(modal => {
              const existingModal = document.querySelector(`#${modal.id}`);
              if (!existingModal) {
                document.body.appendChild(modal.cloneNode(true));
              }
            });
          }
        } else {
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = data.attachment_html;
          const newAttachmentActions = tempDiv.querySelector('.attachment-actions');
          
          if (newAttachmentActions) {
            const uppyButton = fieldElement.querySelector(`button[data-block-id="${blockId}"]`);
            const uppyModal = fieldElement.querySelector(`[id^="uppyModal-"]`) || 
                              fieldElement.querySelector(`[id^="uppy-"]`);
            
            if (uppyButton && uppyButton.parentElement) {
              const buttonParent = uppyButton.parentElement;
              if (buttonParent.parentElement === fieldElement) {
                fieldElement.insertBefore(newAttachmentActions, buttonParent);
              } else {
                fieldElement.insertBefore(newAttachmentActions, uppyButton);
              }
            } else if (uppyModal) {
              fieldElement.insertBefore(newAttachmentActions, uppyModal);
            } else {
              fieldElement.appendChild(newAttachmentActions);
            }
            
            const newModals = tempDiv.querySelectorAll('.file-modal');
            newModals.forEach(modal => {
              const existingModal = document.querySelector(`#${modal.id}`);
              if (!existingModal) {
                document.body.appendChild(modal.cloneNode(true));
              }
            });
          }
        }
        
        if (window.Stimulus) {
          window.Stimulus.load();
        }
        
        if (data.files_count > 0) {
          const blockContainer = blockElement.closest('[data-upload-action]');
          if (blockContainer) {
            blockContainer.setAttribute('data-upload-action', 'add_more');
          }
          
          const fieldElement = blockElement.querySelector('.field');
          const searchContainer = fieldElement || blockElement;
          
          if (searchContainer) {
            const uppyButton = searchContainer.querySelector(`button[data-block-id="${blockId}"][data-action*="uppyClick"]`) ||
                               searchContainer.querySelector(`button[data-block-id="${blockId}"]`);
            
            if (uppyButton) {
              const iconPlus = uppyButton.querySelector('.icon-plus');
              if (!iconPlus) {
                const currentText = uppyButton.textContent.trim();
                const words = currentText.split(/\s+/);
                
                if (words.length >= 2) {
                  const filesText = words[words.length - 1];
                  const iconSpan = document.createElement('span');
                  iconSpan.className = 'icon-plus';
                  uppyButton.innerHTML = '';
                  uppyButton.appendChild(iconSpan);
                  uppyButton.appendChild(document.createTextNode(` Add More ${filesText}`));
                  
                  const currentStyle = uppyButton.getAttribute('style') || '';
                  if (!currentStyle.includes('margin-top')) {
                    uppyButton.setAttribute('style', `${currentStyle} margin-top: 20px;`.trim());
                  }
                }
              }
            }
          }
        }
        
        return;
      }

      
      if (action === 'destroy') {
        
        const taskElement = document.querySelector(`li#task_${taskId}`);
        if (taskElement) {
          const blockElement = taskElement.querySelector(`[data-block-id="${blockId}"]`);
          if (blockElement) {
            blockElement.remove();
          }
        }
        
        
        if (data.task_html) {
          const taskListItem = document.querySelector(`.process#task_list_${data.task_list_id} ol.steps li#task_${taskId}`);
          if (taskListItem) {
            const tmp = document.createElement('div');
            tmp.innerHTML = data.task_html;
            const newTaskElement = tmp.querySelector(`li#task_${taskId}`);
            if (newTaskElement) {
              taskListItem.replaceWith(newTaskElement);
            }
          }
        }
        
       
      } else if (action === 'create' || action === 'update') {
        
        
        if (data.task_content_html) {
          
          const container = document.querySelector(`li#task_${taskId} .tab-panel-content`);
          if (container) {
            
            const taskListItem = document.querySelector(`li#task_${taskId}`);
            const wasExpanded = taskListItem && taskListItem.classList.contains('expanded');
            
            if (blockId) {
              const blockElement = container.querySelector(`[data-block-id="${blockId}"]`);
              if (blockElement) {
                
                const isEditing = window.activeEditingManager && window.activeEditingManager.isBlockBeingEdited(blockId);
                if (isEditing) {
                  return;
                }
                
                
                const tmp = document.createElement('div');
                tmp.innerHTML = data.task_content_html;
                const updatedBlock = tmp.querySelector(`[data-block-id="${blockId}"]`);
                
                if (updatedBlock) {
                  let updated = false;
                  
                  
                  const numberValueElement = blockElement.querySelector('.number-value');
                  const updatedNumberValue = updatedBlock.querySelector('.number-value');
                  if (numberValueElement && updatedNumberValue) {
                    const oldValue = numberValueElement.textContent;
                    const newValue = updatedNumberValue.textContent;
                    if (oldValue !== newValue) {
                      numberValueElement.textContent = newValue;
                      updated = true;
                    }
                  }

                  
                  const numberInputField = blockElement.querySelector('input[type="number"]');
                  const updatedNumberInputField = updatedBlock.querySelector('input[type="number"]');
                  if (numberInputField && updatedNumberInputField && numberInputField.value !== updatedNumberInputField.value) {
                    numberInputField.value = updatedNumberInputField.value;
                    updated = true;
                  }
                  
                 
                  const formulaValueElement = blockElement.querySelector('.formula-value');
                  const updatedFormulaValue = updatedBlock.querySelector('.formula-value');
                  if (formulaValueElement && updatedFormulaValue) {
                    const oldValue = formulaValueElement.textContent;
                    const newValue = updatedFormulaValue.textContent;
                    if (oldValue !== newValue) {
                      formulaValueElement.textContent = newValue;
                      updated = true;
                    }
                  }

                 
                  const textDisplayElement = blockElement.querySelector('[data-target*="textDisplay"], [data-target="text-input.textDisplay"]');
                  const updatedTextDisplay = updatedBlock.querySelector('[data-target*="textDisplay"], [data-target="text-input.textDisplay"]');
                  if (textDisplayElement && updatedTextDisplay) {
                    const oldValue = textDisplayElement.textContent;
                    const newValue = updatedTextDisplay.textContent;
                    if (oldValue !== newValue) {
                      textDisplayElement.textContent = newValue;
                      updated = true;
                    }
                  }

                  
                  const comparisonDisplay = blockElement.querySelector('[data-target*="comparisonDisplay"]');
                  const updatedComparisonDisplay = updatedBlock.querySelector('[data-target*="comparisonDisplay"]');
                  if (comparisonDisplay && updatedComparisonDisplay && comparisonDisplay.outerHTML !== updatedComparisonDisplay.outerHTML) {
                   
                    comparisonDisplay.outerHTML = updatedComparisonDisplay.outerHTML;
                    updated = true;
                  }
                  
                  
                  if (data.block_type === 'description') {
                    
                    blockElement.outerHTML = updatedBlock.outerHTML;
                    updated = true;
                    
                    
                    if (window.Stimulus) {
                      const newBlockElement = container.querySelector(`[data-block-id="${blockId}"]`);
                      if (newBlockElement) {
                        window.Stimulus.load(newBlockElement);
                      }
                    }
                    
                    
                    if (data.account_id && data.project_id && data.task_list_id && taskId && blockId) {
                      const event = new CustomEvent('taskBlockUpdated', {
                        detail: {
                          block_id: blockId,
                          account_id: data.account_id,
                          project_id: data.project_id,
                          task_list_id: data.task_list_id,
                          task_id: taskId,
                          action: 'update'
                        }
                      });
                      document.dispatchEvent(event);

                      let url = `/${data.account_id}/projects/${data.project_id}/task_lists/${data.task_list_id}/tasks/${taskId}/task_blocks/${blockId}/render_referencing_task_blocks`;
                      Rails.ajax({
                        url: url,
                        type: 'GET',
                        dataType: "script"
                      });
                    }
                  }
                  
                  if (updated) {
                    return; 
                  }
                  
                  return; 
                } else {
                  return; 
                }
              }
            }
            
            
            if (action === 'create') {
              
              container.innerHTML = data.task_content_html;
              
             
              if (window.Stimulus) {
                
                const blocks = container.querySelectorAll('[data-controller]');
                blocks.forEach(block => {
                  window.Stimulus.load(block);
                });
               
                window.Stimulus.load();
              }
              
              
              if (wasExpanded && taskListItem) {
                taskListItem.classList.add('expanded');
              }
            } else {
              
              return;
            }
          }
          
          
          if (action === 'create' && data.task_html) {
            const taskListItem = document.querySelector(`.process#task_list_${data.task_list_id} ol.steps li#task_${taskId}`);
            if (taskListItem) {
              const wasExpanded = taskListItem.classList.contains('expanded');
              const tmp = document.createElement('div');
              tmp.innerHTML = data.task_html;
              const newTaskElement = tmp.querySelector(`li#task_${taskId}`);
              if (newTaskElement) {
               
                if (wasExpanded) {
                  newTaskElement.classList.add('expanded');
                }
                
                taskListItem.replaceWith(newTaskElement);
              }
            }
          }
        } else {
          const event = new CustomEvent('taskBlockUpdated', {
            detail: {
              block_id: blockId,
              account_id: data.account_id,
              project_id: data.project_id,
              task_list_id: data.task_list_id,
              task_id: taskId,
              action: action
            }
          });
          document.dispatchEvent(event);

          let url = `/${data.account_id}/projects/${data.project_id}/task_lists/${data.task_list_id}/tasks/${taskId}/task_blocks/${blockId}/render_referencing_task_blocks`;
          let type = 'GET';

          Rails.ajax({
            url: url,
            type: type,
            dataType: "script"
          });
        }
      } else {
        if (blockId && taskId) {
          const container = document.querySelector(`li#task_${taskId} .tab-panel-content`);
          const blockElement = container ? container.querySelector(`[data-block-id="${blockId}"]`) : null;
        
          if (blockElement) {
        const event = new CustomEvent('taskBlockUpdated', {
          detail: {
            block_id: blockId,
            account_id: data.account_id,
            project_id: data.project_id,
            task_list_id: data.task_list_id,
            task_id: taskId
          }
        });
        document.dispatchEvent(event);

        let url = `/${data.account_id}/projects/${data.project_id}/task_lists/${data.task_list_id}/tasks/${taskId}/task_blocks/${blockId}/render_referencing_task_blocks`;
        let type = 'GET';

        Rails.ajax({
          url: url,
          type: type,
          dataType: "script"
        });
          }
        }
      }
    }
  });
});
